import Vue from 'vue';
var ProcessStatus;

Vue.util.extend(
    (ProcessStatus = function(initialState) {
        this.initialState = initialState;
        this.state = initialState;
        this.messages = [];
        this.responsesRaw = [];
    }).prototype,
    {
        MESSAGE_TYPE_ERROR: "error",
        MESSAGE_TYPE_LOG: "log",
        reset: function(params) {
            params = params || "default";
            params = (params == "default") ? "messages|responsesRaw" : params;
            params = (params == "all") ? "messages|responsesRaw|state" : params;
            params.split(/\|/).forEach(param => {
                if (param == "messages") {
                    this.messages.splice(0, this.messages.length);
                }
                if (param == "responsesRaw") {
                    this.responsesRaw.splice(0, this.responsesRaw.length);
                }
                if (param == "state") {
                    this.state = this.initialState;
                }
            });
        },
        push: function(type, message, responseRaw) {
            if (message) {
                type = type || this.MESSAGE_TYPE_LOG;
                this.messages.push({
                    type: type,
                    message: message
                });
            }
            if (responseRaw) {
                this.responsesRaw.push(responseRaw);
            }
        },
        log: function(message, responseRaw) {
            return this.push(this.MESSAGE_TYPE_LOG, message, responseRaw);
        },
        error: function(message, responseRaw) {
            return this.push(this.MESSAGE_TYPE_ERROR, message, responseRaw);
        }
    }
);

export default ProcessStatus;